module.exports = __webpack_public_path__ + "img/mp4.85648954.png";